import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLiveWeak: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="live-weak, signal"><path d="M8.36647 8.36719C7.43652 9.29714 6.86133 10.5819 6.86133 12.0009C6.86133 13.42 7.43652 14.7047 8.36647 15.6347M15.634 15.6347C16.5639 14.7047 17.1391 13.42 17.1391 12.0009C17.1391 10.5819 16.5639 9.29714 15.634 8.36719M12.7502 12.0002C12.7502 12.4144 12.4144 12.7502 12.0002 12.7502C11.586 12.7502 11.2502 12.4144 11.2502 12.0002C11.2502 11.586 11.586 11.2502 12.0002 11.2502C12.4144 11.2502 12.7502 11.586 12.7502 12.0002Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLiveWeak;
